import type { MomentAnalyticsCellDataDisplay } from "../hooks/utils";
import type { FC } from "react";

export const ValueCellDisplay: FC<{
  cellData?: MomentAnalyticsCellDataDisplay;
}> = ({ cellData }) => (
  <>
    {cellData?.type === "number" && <>{cellData.value}</>}
    {cellData?.type === "percentage" && <>{`${cellData.value}%`}</>}
    {cellData?.type === null && <>-</>}
  </>
);
